import styled from 'styled-components';
import { horizontalScrollBar } from 'stylesheet';
export var OptimizationContainer = styled.div.withConfig({
  displayName: "YTGOptimizationLevelsstyle__OptimizationContainer",
  componentId: "sc-11xd6iu-0"
})(["width:100%;overflow:hidden;", ""], horizontalScrollBar);